/** Explicit project-wide approval only; all other wording stays in conversation. */
export function hasMergeIntent(text) {
    if (typeof text !== 'string')
        return false;
    const t = text.trim().replace(/\s+/g, ' ');
    return t.length > 0 && t.length <= 160
        && /^(?:(?:can|could|would) you )?(?:please )?merge (?:(?:all(?: of)? )?(?:(?:the|these|those) )?(?:open )?(?:fix )?(?:prs|pull requests))(?: please)?[.!?]*$/i.test(t);
}
//# sourceMappingURL=merge-intent.js.map